import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const headCells = [
    { id: '', label: 'AÑOS', width: '30px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    { id: '', label: 'MES', width: '80px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    { id: '', label: 'MONTO', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    { id: '', label: 'INTERES MORA', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    { id: '', label: 'RECARGO', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    { id: '', label: 'DESCUENTO', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    { id: '', label: 'N° RECIBO', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: '', label: 'FECHA DE PAGO', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
]


const TablaHistoricosApuestas = props => {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [activate, setActivate] = useState(false);
    const [idAgente, setIdAgente] = useState();
    const [periodo, setPeriodo] = useState();
    let op = require('../../../../src/modulos/datos');

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 320);

    const [url, setUrl] = useState('');

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (('R' || x.idfactura).includes(target.value)
                            || moment.utc(x.fechaenterami).format('DD/MM/YYYY').includes(target.value)
                            || x.periodo.toLowerCase().includes(target.value.toLowerCase())
                            || x.numrete.toString().toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.montorete.toString().replace('.', ','), ',', '.', 2).includes(target.value)
                            || x.descristatus.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    useEffect(() => {


        if (props.tabreten) {
            setRecords(props.tabreten);
        }

    }, [props.tabreten]);


    const eliminarRetencion = (id, peri, status) => (event) => {
        if (status === 'Por pagar' || status === 'Rechazada') {
            setIdAgente(id);
            setPeriodo(peri);
            setTitulo("Corfirmar");
            setMsg("Esta seguro de eliminar las Retenciones del período " + peri + " ?");
            setMostrar3(true);
        } else {
            setTitulo("Advertencia");
            setMsg("No se puede eliminar la Retenciones por que se encuentra " + status + ".");
            setMostrar(true);
        }
    };

    const handleCloseNo = () => {
        setMostrar3(false);
    }

    const handleCloseSi = () => {
        setContar(0);
        setMostrar3(false);
        setActivate(true);
        /* DeleteReten({
            variables: {
                idcomer: idAgente,
                peri: periodo
                
            }
        }); */
        /*condicion: "agenteretencion = " + idAgente + 
                            " AND periodo = '" + periodo + "'"*/
    }

    const handleCloseMensa = () => {
        setMostrar(false);

    }

    const imprimirRetencion = (factura) => (event) => {

        event.preventDefault();

        //var reporte ='PlanillaRetencionAraure';
        var reporte = 'PlanillaRetencionAcarigua';

        window.open(op.reportes + "reporte=" + reporte + "&id=" + factura.trim() + "&viene=" + props.espiritu + "&factura=" + factura.replace("R", ""), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    }

    return (
        <div className="card">
            {/* <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} /> */}

            {/*< MensajeSiNo titulo={titulo} mensaje={msg}
                show={mostrar3}
                onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer> */}
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row col-md-12">

                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.idfactura + item.periodo} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{'R' + item.idfactura}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechaenterami).format('DD/MM/YYYY')}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.periodo}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{item.numrete}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.montorete.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descristatus}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descristatus}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descristatus}</td>
                                                    {/* <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "60px", padding: 0 }}>
                                                        <button style={{ width: "40px" }} onClick={imprimirRetencion(item.idfactura)} className="btn btn-outline-primary"><i className="fas fa-print"></i> </button>
                                                        <a> &nbsp; </a>
                                                        {props.operacion === 2 ?
                                                            <button style={{ width: "40px" }} onClick={eliminarRetencion(item.agenteretencion, item.periodo, item.descristatus)} className="btn btn-outline-danger"><i className="fas fa-trash-alt"></i> </button>
                                                            : '' 
                                                        }
                                                    </td> */}
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                {/*<TblPagination />*/}

                            </div>

                            <div className='col-md-12' style={{margin:'auto'}}>
                                <div className='col-md-2 mx-auto' >
                                    <button style={{ marginBottom: "10px", margin: "auto" }} /* onClick={imprimirDeudaGeneral} */ className="btn btn-primary"><i className="fas fa-print"> Imprimir </i> </button>
                                </div>

                            </div>
                            <div align="center" className="col-md-12">
                                <a> &nbsp; </a>
                            </div>
                            {/*                             <div align="center" className="col-md-12">
                                <button style={{ marginBottom: "10px" }} className="btn btn-outline-primary"><i className="fas fa-print"> Imprimir </i> </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}


export default TablaHistoricosApuestas;
